import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeather: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFeather"><Path d="M4.5 21.5C4.5 12 8.25 2.5 19.5 2.5C19.5 6.72222 14.6786 9.88889 14.6786 9.88889L16.8214 11.4722C16.8214 11.4722 15 18.5 5 18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFeather;
